import React, { createContext, useCallback, useContext, useState } from "react";

const LoadingContext = createContext(null);

export const LoadingProvider = ({ children }) => {
  const [requestCount, setRequestCount] = useState(0);

  const startLoading = useCallback(() => {
    setRequestCount((prev) => prev + 1);
  }, []);

  const stopLoading = useCallback(() => {
    setRequestCount((prev) => Math.max(0, prev - 1));
  }, []);

  return (
    <LoadingContext.Provider
      value={{ isLoading: requestCount > 0, startLoading, stopLoading }}
    >
      {children}
    </LoadingContext.Provider>
  );
};

export const useLoading = () => useContext(LoadingContext);
